import { EstimateStructureContext } from "./EstimateStructureContext";

export const EstimateStructureProvider = EstimateStructureContext.Provider;